import React from "react";

// External

// Internal
import Layout from "../components/layout";
import Seo from "../components/SEO";
import ContactMeSection from "../containers/contact-me-section";

const ContactMePage = () => {
  return (
    <Layout>
      <Seo
        title="Contact me"
        description="Work query & contact details for Parmeet Singh Asija"
      />
      <ContactMeSection />
    </Layout>
  );
};

export default ContactMePage;
